import { render, staticRenderFns } from "./Colegiado.vue?vue&type=template&id=49f7016d&scoped=true&"
import script from "./Colegiado.vue?vue&type=script&lang=js&"
export * from "./Colegiado.vue?vue&type=script&lang=js&"
import style0 from "./Colegiado.vue?vue&type=style&index=0&id=49f7016d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f7016d",
  null
  
)

export default component.exports